const getScript = (url, data) => {
  return new Promise((resolve, reject) => {
    $.get(url, data, null, 'script')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default getScript;
